import { Injectable } from '@angular/core';

@Injectable()
export class LogUtilService {
  constructor() {}

  static obfuscateJsonObject(jsonObj: any, fieldNames: string[]) {
    try {
      // Function to recursively obfuscate specified fields
      function obfuscateFields(obj: any) {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (fieldNames.includes(key)) {
              const valueToObfuscate = obj[key] || '';
              obj[key] = LogUtilService.obfuscateValue(valueToObfuscate);
            } else if (typeof obj[key] === 'object') {
              // Recursively obfuscate fields in nested objects or arrays
              obfuscateFields(obj[key]);
            }
          }
        }
      }

      obfuscateFields(jsonObj);
      return JSON.stringify(jsonObj) || '';
    } catch (e) {
      console.error('Error obfuscating fields', e);
      return '';
    }
  }

  // Function to check if a key exists deeply in an object
  static hasKeyDeep(obj: any, key: string): boolean {
    if (typeof obj !== 'object' || obj === null) {
      return false;
    }

    if (key in obj) {
      return true;
    }

    return Object.values(obj).some((value) => LogUtilService.hasKeyDeep(value, key));
  }

  static obfuscateJsonString(jsonString: string, fieldNames: string[]): string {
    try {
      const jsonObj = JSON.parse(jsonString);
      return this.obfuscateJsonObject(jsonObj, fieldNames);
    } catch (e) {
      console.error('Error obfuscating fields', e);
      return jsonString || '';
    }
  }

  private static obfuscateValue(value: string): string {
    if (value.length <= 1) {
      return value;
    }
    // For strings of length 2 or more, return the first character, the obfuscated part, and the last character
    return value[0] + '*'.repeat(value.length - 2) + value[value.length - 1];
  }
}
